import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useHistory, useLocation } from 'react-router-dom';
import DrawerMenu from './Drawer/DrawerMenu';
import ContentTabs from './ContentTabs/ContentTabs';
import Header from '../Header/Header';
import AddTicketPopUp from '../AddTicketPopUp/AddTicketPopUp';
import CancelEditPopUp from '../CancelEditPopUp/CancelEditPopUp';
import {
  drawerOpenedState,
  setDrawerOpened,
  setAddTicket,
  fetchAllWagonNumbers,
  editTicketState,
  addTicketState,
  fetchAllDamageCodes,
  selectedMenuTabState,
  setSelectedMenuTab,
} from './ContentTabs/ContentTabsSlice';
import {
  setUserInfo,
  setNotifications,
  selectedBusinessUnitsState,
  setAllBusinessUnits,
  setActualWorkshopsList,
} from './HomeSlice';
import {
  fetchAllOpenTickets,
  fetchAllClosedTickets,
  fetchAllTickets,
  setCurrentViewName,
} from './TicketList/TicketListSlice';
import ApiService from '../../services/ApiService';

import useStyles from './styles';
import CancelPopUp from '../AddInvoicePage/ConfirmationPopUps/CancelPopUp';
import AppConstants from '../../common/constants/AppConstants';

function HomePage() {
  const classes = useStyles();
  const drawerOpened = useSelector(drawerOpenedState);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [openCancelPopUp, setOpenCancelEditPopUp] = React.useState(false);
  const [openCancelAddInvoicePopUp, setOpenCancelAddInvoiceEditPopUp] =
    React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState('');

  const editTicket = useSelector(editTicketState);
  const addTicket = useSelector(addTicketState);
  const history = useHistory();
  const selectedBusinessUnits = useSelector(selectedBusinessUnitsState);
  const selectedMenuTab = useSelector(selectedMenuTabState);

  const isWorkshopTimePage = useLocation().pathname.startsWith(
    '/analytics/workshop-time',
  );

  const enableJiraReporting = () => {
    const existingScript = document.getElementById('jiraAccess');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = AppConstants?.jiraUrl;
      script.id = 'jiraAccess';
      document.body.appendChild(script);
    }
  };

  const enableOpsToolReporting = () => {
    if (
      !AppConstants?.help?.helpLinks.some(
        (links) => links.title === 'Raise incident',
      )
    ) {
      const opsTool = {
        title: 'Raise incident',
        link:
          process.env.REACT_APP_STAGE === 'prod'
            ? AppConstants.opsProdUrl
            : AppConstants.opsNonProdUrl,
      };

      AppConstants?.help?.helpLinks.push(opsTool);
    }
  };

  useEffect(() => {
    if (!isWorkshopTimePage) {
      dispatch(fetchAllDamageCodes());

      ApiService.getAllActualWorkshops().then((response) => {
        dispatch(setActualWorkshopsList(response));
      });
    }

    ApiService.getUserInfo().then((response) => {
      dispatch(setUserInfo(response.data));
      if (
        response.data.internal ||
        response.data.hasEmilyDRights ||
        response.data.externalMax
      ) {
        if (!response.data.externalMax) {
          enableJiraReporting();
        }
        enableOpsToolReporting();
        if (!isWorkshopTimePage) {
          dispatch(fetchAllOpenTickets());
          dispatch(fetchAllClosedTickets());
          dispatch(fetchAllWagonNumbers());
        }
        if (selectedBusinessUnits) {
          ApiService.filterNotificationsByBusinessUnits(
            selectedBusinessUnits,
          ).then((notifications) => {
            dispatch(setNotifications(notifications.data));
          });
        } else {
          ApiService.getLatestNotifications().then((notifications) => {
            const list = [];
            dispatch(setNotifications(notifications.data));
            notifications.data.forEach((notification) => {
              if (!list.includes(notification.businessUnit)) {
                list.push(notification.businessUnit);
              }
            });
            dispatch(setAllBusinessUnits(list));
          });
        }
      } else {
        dispatch(setCurrentViewName('tickets'));
        if (!isWorkshopTimePage) {
          dispatch(fetchAllTickets());
        }
        if (response.data.hasAllRights) {
          enableJiraReporting();
          enableOpsToolReporting();
        }
      }
    });
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  function handleDrawerOpenedChange(newValue) {
    dispatch(setDrawerOpened(newValue));
  }

  function handleSelectedTabChange(newValue) {
    setSelectedTab(newValue);
    if (newValue === 'ticket') {
      handleClickOpen();
    } else if (editTicket || addTicket) {
      setOpenCancelEditPopUp(true);
    } else if (
      newValue !== 'addInvoices' &&
      selectedMenuTab === 'addInvoices'
    ) {
      setOpenCancelAddInvoiceEditPopUp(true);
    } else {
      dispatch(setAddTicket(false));
      setOpen(false);
    }
  }
  function getAddTicketState(addTicketValue) {
    dispatch(setAddTicket(addTicketValue));
  }
  function handleClose(openState) {
    setOpen(openState);
  }
  const handleClickAway = () => {
    dispatch(setDrawerOpened(false));
  };

  function confirmCancelEditTicket() {
    dispatch(setAddTicket(false));
    setOpenCancelEditPopUp(false);
    if (selectedTab === 'totalTickets') {
      dispatch(setSelectedMenuTab('ticketList'));
      history.push('/');
    } else if (selectedTab === 'wagonDetails') {
      dispatch(setSelectedMenuTab('ticketHistoric'));
      history.push('/wagon/search');
    } else if (selectedTab === 'addInvoices') {
      dispatch(setSelectedMenuTab('addInvoices'));
      history.push('/invoices/add');
    } else if (selectedTab === 'invoicesResearch') {
      dispatch(setSelectedMenuTab('invoicesResearch'));
      history.push('/invoices/research');
    } else if (selectedTab === 'wagonAvailability') {
      dispatch(setSelectedMenuTab('wagonAvailability'));
      history.push('/analytics/wagon-availability');
    } else if (selectedTab === 'wagonSimulation') {
      dispatch(setSelectedMenuTab('wagonSimulation'));
      history.push('/analytics/wagon-simulation');
    } else if (selectedTab === 'maintenanceStatus') {
      dispatch(setSelectedMenuTab('maintenanceStatus'));
      history.push('/analytics/maintenance-status');
    } else if (selectedTab === 'workshopTime') {
      dispatch(setSelectedMenuTab('workshopTime'));
      history.push('/analytics/workshop-time');
    } else if (selectedTab === 'totalCost') {
      dispatch(setSelectedMenuTab('totalCost'));
      history.push('/analytics/total-cost');
    } else if (selectedTab === 'monitoring') {
      dispatch(setSelectedMenuTab('monitoring'));
      history.push('/analytics/monitoring');
    } else if (selectedTab === 'revisionParameters') {
      dispatch(setSelectedMenuTab('revisionParameters'));
      history.push('/parameters/revision');
    } else if (selectedTab === 'plannedPrediction') {
      dispatch(setSelectedMenuTab('plannedPrediction'));
      history.push('/revisionplan/plannedprediction');
    } else if (selectedTab === 'revisionPlanUpload') {
      dispatch(setSelectedMenuTab('revisionPlanUpload'));
      history.push('/revisionplan/revisionPlanUpload');
    } else if (selectedTab === 'parameterAr') {
      dispatch(setSelectedMenuTab('parameterAr'));
      history.push('/parameters/parameterAr');
    } else if (selectedTab === 'businessNeed') {
      dispatch(setSelectedMenuTab('businessNeed'));
      history.push('/parameters/businessNeed');
    }
  }

  function confirmCancelAddInvoice() {
    setOpenCancelAddInvoiceEditPopUp(false);
    if (selectedTab === 'totalTickets') {
      dispatch(setSelectedMenuTab('ticketList'));
      history.push('/');
    } else if (selectedTab === 'wagonDetails') {
      dispatch(setSelectedMenuTab('ticketHistoric'));
      history.push('/wagon/search');
    } else if (selectedTab === 'ticket') {
      dispatch(setSelectedMenuTab('addInvoices'));
      history.push('/invoices/add');
    } else if (selectedTab === 'invoicesResearch') {
      dispatch(setSelectedMenuTab('invoicesResearch'));
      history.push('/invoices/research');
    } else if (selectedTab === 'wagonAvailability') {
      dispatch(setSelectedMenuTab('wagonAvailability'));
      history.push('/analytics/wagon-availability');
    } else if (selectedTab === 'wagonSimulation') {
      dispatch(setSelectedMenuTab('wagonSimulation'));
      history.push('/analytics/wagon-simulation');
    } else if (selectedTab === 'maintenanceStatus') {
      dispatch(setSelectedMenuTab('maintenanceStatus'));
      history.push('/analytics/maintenance-status');
    } else if (selectedTab === 'workshopTime') {
      dispatch(setSelectedMenuTab('workshopTime'));
      history.push('/analytics/workshop-time');
    } else if (selectedTab === 'totalCost') {
      dispatch(setSelectedMenuTab('totalCost'));
      history.push('/analytics/total-cost');
    } else if (selectedTab === 'monitoring') {
      dispatch(setSelectedMenuTab('monitoring'));
      history.push('/analytics/monitoring');
    }
  }

  return (
    <div className={classes.root}>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <Header
            drawerOpened={drawerOpened}
            onChange={handleDrawerOpenedChange}
          />
          <DrawerMenu
            drawerOpened={drawerOpened}
            onChange={handleSelectedTabChange}
          />
        </div>
      </ClickAwayListener>
      <ContentTabs
        drawerOpened={drawerOpened}
        onChange={handleDrawerOpenedChange}
      />
      <AddTicketPopUp
        open={open}
        setAddTicketState={getAddTicketState}
        setPopUpOpenedState={handleClose}
      />
      <CancelEditPopUp
        editTicket={editTicket}
        openCancelPopUp={openCancelPopUp}
        confirmCancel={confirmCancelEditTicket}
        closeCancelPopUp={() => setOpenCancelEditPopUp(false)}
      />
      <CancelPopUp
        editMode={false}
        openCancelPopUp={openCancelAddInvoicePopUp}
        confirmCancel={confirmCancelAddInvoice}
        closeCancelPopUp={() => setOpenCancelAddInvoiceEditPopUp(false)}
      />
    </div>
  );
}
export default HomePage;
